// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as BigJs from "big.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as ToggleButtonGroup from "../../resources/actions/ToggleButtonGroup.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CartDiscount__Utils from "./CartDiscount__Utils.res.js";

function makeDefaultDiscount(product) {
  let quantity;
  quantity = product.TAG === "Unit" ? product._0.quantity : product._0.quantity.toNumber();
  return {
    name: "",
    kind: "Percent",
    value: 0,
    quantity: BigJs.Big(quantity),
    id: "",
    formattedValue: undefined,
    amount: undefined,
    formattedAmount: undefined,
    warnings: []
  };
}

function CartProductDiscountFieldset(props) {
  let dispatch = props.onRequestDispatch;
  let onPressRemoveDiscount = props.onPressRemoveDiscount;
  let __discount = props.discount;
  let product = props.product;
  let discount = __discount !== undefined ? __discount : makeDefaultDiscount(product);
  let match = React.useState(() => discount.value);
  let setValue = match[1];
  let value = match[0];
  let match$1;
  let exit = 0;
  let id;
  let totalLocalDiscounts;
  let formattedTotalPrice;
  if (product.TAG === "Unit") {
    let match$2 = product._0;
    id = match$2.id;
    totalLocalDiscounts = match$2.totalLocalDiscounts;
    formattedTotalPrice = match$2.formattedTotalPrice;
    exit = 1;
  } else {
    let match$3 = product._0;
    id = match$3.id;
    totalLocalDiscounts = match$3.totalLocalDiscounts;
    formattedTotalPrice = match$3.formattedTotalPrice;
    exit = 1;
  }
  if (exit === 1) {
    let formattedTotalLocalDiscounts = Stdlib_Option.map(totalLocalDiscounts, value => I18n.decimalFormat(undefined, 3, 3, undefined, value.toNumber()));
    match$1 = [
      id,
      formattedTotalPrice,
      formattedTotalLocalDiscounts
    ];
  }
  let productId = match$1[0];
  let match$4;
  match$4 = product.TAG === "Unit" ? [
      product._0.quantity,
      0
    ] : [
      product._0.quantity.toNumber(),
      product._1
    ];
  let productQuantity = match$4[0];
  let totalPrice;
  if (product.TAG === "Unit") {
    let totalPrice$1 = product._0.totalPrice;
    totalPrice = totalPrice$1 !== undefined ? Primitive_option.valFromOption(totalPrice$1).toNumber() : 0;
  } else {
    let totalPrice$2 = product._0.totalPrice;
    totalPrice = totalPrice$2 !== undefined ? Primitive_option.valFromOption(totalPrice$2).toNumber() : 0;
  }
  let discountExists = discount.id !== "";
  ReactUpdateEffect.use1(() => {
    if (!discountExists && value > 0) {
      dispatch({
        TAG: "ProductDiscountAdded",
        _0: productId,
        _1: {
          id: undefined,
          name: "",
          kind: "Percent",
          value: value,
          quantity: 0
        }
      });
    } else {
      let match = discount.kind;
      let tmp;
      switch (match) {
        case "Currency" :
          tmp = {
            name: discount.name,
            kind: discount.kind,
            value: value > totalPrice ? totalPrice : value,
            quantity: discount.quantity,
            id: discount.id,
            formattedValue: discount.formattedValue,
            amount: discount.amount,
            formattedAmount: discount.formattedAmount,
            warnings: discount.warnings
          };
          break;
        case "Percent" :
          tmp = {
            name: discount.name,
            kind: discount.kind,
            value: value > 100 ? 100 : value,
            quantity: discount.quantity,
            id: discount.id,
            formattedValue: discount.formattedValue,
            amount: discount.amount,
            formattedAmount: discount.formattedAmount,
            warnings: discount.warnings
          };
          break;
        case "Free" :
          tmp = {
            name: discount.name,
            kind: discount.kind,
            value: discount.value,
            quantity: value > productQuantity ? BigJs.Big(productQuantity) : BigJs.Big(value),
            id: discount.id,
            formattedValue: discount.formattedValue,
            amount: discount.amount,
            formattedAmount: discount.formattedAmount,
            warnings: discount.warnings
          };
          break;
      }
      dispatch({
        TAG: "ProductDiscountUpdated",
        _0: productId,
        _1: discount.id,
        _2: tmp
      });
    }
  }, [value]);
  let onDiscountKindChange = React.useCallback(kind => {
    if (discountExists) {
      return dispatch({
        TAG: "ProductDiscountUpdated",
        _0: productId,
        _1: discount.id,
        _2: {
          name: discount.name,
          kind: kind,
          value: 0,
          quantity: discount.quantity,
          id: discount.id,
          formattedValue: discount.formattedValue,
          amount: discount.amount,
          formattedAmount: discount.formattedAmount,
          warnings: discount.warnings
        }
      });
    } else {
      return dispatch({
        TAG: "ProductDiscountAdded",
        _0: productId,
        _1: {
          id: undefined,
          name: "",
          kind: kind,
          value: 0,
          quantity: 0
        }
      });
    }
  }, [discount]);
  let onPressRemoveDiscount$1 = React.useCallback(() => {
    dispatch({
      TAG: "ProductDiscountRemoved",
      _0: productId,
      _1: discount.id
    });
    onPressRemoveDiscount();
  }, [discount.id]);
  let match$5 = discount.kind;
  let tmp;
  switch (match$5) {
    case "Currency" :
      let match$6 = discount.warnings;
      let tmp$1;
      if (match$6.length !== 1) {
        tmp$1 = null;
      } else {
        let warning = match$6[0];
        tmp$1 = JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(TextStyle.make, {
            children: I18n.template(CartDiscount__Utils.discountWarningToText(warning), {
              max: match$1[1]
            }, undefined),
            size: "xsmall"
          }),
          spaceX: "xsmall"
        });
      }
      tmp = JsxRuntime.jsxs(Stack.make, {
        children: [
          JsxRuntime.jsx(InputNumberField.make, {
            value: value,
            minValue: 0,
            maxValue: totalPrice,
            precision: 3,
            label: I18n.t("Discount amount"),
            appender: {
              TAG: "Currency",
              _0: "EUR"
            },
            onChange: value => setValue(param => value)
          }),
          tmp$1
        ],
        space: "xsmall"
      });
      break;
    case "Percent" :
      tmp = JsxRuntime.jsx(InputNumberField.make, {
        value: value,
        minValue: 0,
        maxValue: 100,
        precision: 2,
        label: I18n.t("Discount percentage"),
        appender: "Percent",
        onChange: value => setValue(param => value)
      });
      break;
    case "Free" :
      let inputAppender;
      let exit$1 = 0;
      if (product.TAG === "Unit") {
        exit$1 = 1;
      } else {
        let unit = product._0.capacityUnit;
        if (unit !== undefined) {
          inputAppender = {
            TAG: "Custom",
            _0: `/ ` + productQuantity.toString().replace(".", ",") + ` ` + unit
          };
        } else {
          exit$1 = 1;
        }
      }
      if (exit$1 === 1) {
        inputAppender = {
          TAG: "Custom",
          _0: `/ ` + productQuantity.toString()
        };
      }
      tmp = JsxRuntime.jsx(InputNumberField.make, {
        value: discount.quantity.toNumber(),
        minValue: 0,
        maxValue: productQuantity,
        precision: match$4[1],
        label: I18n.t("Quantity offered"),
        appender: inputAppender,
        onChange: value => setValue(param => value)
      });
      break;
  }
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsx(ToggleButtonGroup.make, {
            label: I18n.t("Discount type"),
            items: [
              {
                key: "percent",
                value: "Percent",
                icon: "percent"
              },
              {
                key: "currency",
                value: "Currency",
                icon: "currency"
              },
              {
                key: "free",
                label: CartDiscount__Utils.kindToText("Free"),
                value: "Free"
              }
            ],
            value: {
              TAG: "Single",
              _0: discount.kind
            },
            onChange: selection => {
              if (typeof selection !== "object" || selection.TAG !== "Single") {
                return;
              } else {
                return onDiscountKindChange(selection._0);
              }
            }
          }),
          tmp
        ],
        grid: [
          "1fr",
          "max-content"
        ],
        wrap: false,
        spaceX: "medium"
      }),
      JsxRuntime.jsxs(Stack.make, {
        children: [
          JsxRuntime.jsx(TextStyle.make, {
            children: I18n.template(I18n.t("Total discount : {{amount}}"), {
              amount: Stdlib_Option.getOrThrow(match$1[2], undefined)
            }, undefined),
            weight: "strong"
          }),
          JsxRuntime.jsx(Inline.make, {
            children: JsxRuntime.jsx(Button.make, {
              label: I18n.t("Remove discount"),
              variant: "subtle",
              icon: "delete",
              onPress: onPressRemoveDiscount$1
            }),
            align: "end"
          })
        ],
        space: "none"
      })
    ],
    space: "medium"
  });
}

let make = React.memo(CartProductDiscountFieldset, (oldProps, newProps) => {
  if (oldProps.product === newProps.product) {
    return oldProps.discount === newProps.discount;
  } else {
    return false;
  }
});

let Utils;

export {
  Utils,
  makeDefaultDiscount,
  make,
}
/* make Not a pure module */
